if (!customElements.get('gfe-chakra-versions')) {
  customElements.define('gfe-chakra-versions', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.context = this.closest('[data-version-context]');
      if (!this.context) return;
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-practice-version]');
        if (button && this.contains(button)) this.select(button, true);
      }, options);
      this.context.addEventListener('click', event => {
        if (event.target.closest('[data-select-full]')) {
          const fullButton = this.querySelector('[data-practice-version="full"]');
          this.select(fullButton, true);
          if (fullButton) fullButton.focus({ preventScroll:true });
          if (this.dataset.scope === 'guide') this.scrollIntoView({ block:'center', behavior:'auto' });
        }
      }, options);
      this.select(this.querySelector('[data-practice-version="full"]'), false);
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
    select(button, changeMedia) {
      if (!button || !this.context) return;
      const selected = button.dataset.practiceVersion;
      if (changeMedia && this.context.dataset.currentVersion === selected) return;
      this.context.dataset.currentVersion = selected;
      this.querySelectorAll('[data-practice-version]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      this.context.querySelectorAll('[data-full-only]').forEach(item => item.hidden = selected !== 'full');
      this.context.querySelectorAll('[data-short-only]').forEach(item => item.hidden = selected !== 'short');
      this.context.querySelectorAll('[data-version-meta]').forEach(item => item.textContent = button.dataset.meta);
      if (!changeMedia) return;
      if (this.dataset.scope === 'guide') this.changeGuideMedia(button);
      this.dispatchEvent(new CustomEvent('gfe:practice-version', { bubbles:true, detail:{ button, version:selected } }));
    }
    changeGuideMedia(button) {
      const mount = this.context.querySelector('[data-version-player]');
      if (!mount) return;
      mount.querySelectorAll('video').forEach(video => { video.pause(); video.removeAttribute('src'); video.load(); });
      let player;
      const source = button.dataset.mediaSource;
      const id = button.dataset.mediaId;
      if (source) {
        const url = new URL(source, window.location.origin);
        if (!['http:', 'https:'].includes(url.protocol)) return;
        player = document.createElement('video');
        player.src = url.href;
        player.controls = true;
        player.playsInline = true;
        player.preload = 'metadata';
        if (button.dataset.mediaPoster) player.poster = button.dataset.mediaPoster;
        player.setAttribute('aria-label', button.dataset.mediaTitle);
      } else if (/^[a-zA-Z0-9_-]{11}$/.test(id || '')) {
        player = document.createElement('iframe');
        player.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=0&rel=0&playsinline=1`;
        player.title = button.dataset.mediaTitle;
        player.allow = 'encrypted-media; picture-in-picture; fullscreen';
        player.allowFullscreen = true;
        player.referrerPolicy = 'strict-origin-when-cross-origin';
      }
      const external = this.context.querySelector('[data-version-external]');
      if (external) {
        external.hidden = !id || Boolean(source);
        if (id) external.href = `https://www.youtube.com/watch?v=${id}`;
      }
      if (player) mount.replaceChildren(player);
      else if (button.dataset.mediaPoster) {
        const poster = document.createElement('img');
        poster.src = button.dataset.mediaPoster;
        poster.alt = button.dataset.mediaTitle;
        mount.replaceChildren(poster);
      } else mount.replaceChildren();
    }
  });
}
